export class LcuUtils {

    public static upperLcu(input: string): string {
        return input.toUpperCase();
    }
}
